import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { ItemService } from '../../services/item.service';

@Component({
  selector: 'user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {

  hideNav: any;
  isNewUser = true;
  email = '';
  password = '';
  errorMessage = '';
  error: { name: string, message: string } = { name: '', message: '' };
  resetPassword = false;
  
  constructor(public authService: AuthService, private router: Router, private itemService: ItemService) { }


  async ngOnInit() {
    this.hideNav = true;
    if (this.authService.logout) {

    } else {
      if (this.authService.currentUser) {
        ///  alert('login user');
        
        // this.router.navigate(['/activity/dashboard']);
        this.router.navigate(['/home'])
        
      }
    }
  }

  checkUserInfo() {
    if (this.authService.isUserEmailLoggedIn) {
      // this.router.navigate(['/activity/dashboard'])
      this.router.navigate(['/home'])
      
    }
  }

  clearErrorMessage() {
    this.errorMessage = '';
    this.error = { name: '', message: '' };
  }

  changeForm() {
    this.isNewUser = !this.isNewUser
  }

  // onSignUp(): void {
  //   this.clearErrorMessage()

  //   if (this.validateForm(this.email, this.password)) {
  //     this.authService.signUpWithEmail(this.email, this.password)
  //       .then(() => {
  //         this.router.navigate(['/home'])
  //       }).catch(_error => {
  //         this.error = _error
  //         this.router.navigate(['/'])
  //       })
  //   }
  // }

  onLoginEmail(): void {
    this.clearErrorMessage()

    if (this.validateForm(this.email, this.password)) {
      this.authService.loginWithEmail(this.email, this.password)
        .then(() => {
          let parameters:any = { attempt: 'Success'}
          this.itemService.logEvent('onLogin', parameters);

          this.hideNav = null;
          // this.router.navigate(['/activity/dashboard'])
          this.router.navigate(['/home'])
        })
        .catch(_error => { 
          this.error = _error;
          // let timestamp = Date.now().toString();
          // let parameters:any = { username:this.email, password:this.password, attempt: 'Failed', error: this.error}
          // this.itemService.logEvent('onLogin', 'null', timestamp, parameters);
          this.router.navigate(['/'])
        })
    } 
  }

  validateForm(email: string, password: string): boolean {
    if (email.length === 0) {
      this.errorMessage = 'Please enter Email!'
      return false
    }

    if (password.length === 0) {
      this.errorMessage = 'Please enter Password!'
      return false
    }

    if (password.length < 6) {
      this.errorMessage = 'Password should be at least 6 characters!'
      return false
    }

    this.errorMessage = ''

    return true
  }

  isValidMailFormat(email: string) {
    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if ((email.length === 0) && (!EMAIL_REGEXP.test(email))) {
      return false;
    }

    return true;
  }

  // sendResetEmail() {
  //   this.clearErrorMessage()

  //   this.authService.resetPassword(this.email)
  //     .then(() => this.resetPassword = true)
  //     .catch(_error => {
  //       this.error = _error
  //     })
  // }
}



// WEBPACK FOOTER //
// ./src/app/auth/user-login/user-login.component.ts